import MaxWidthLimiter from 'containers/max-width-limiter/max-width-limiter'
import FooterDesktop from './footer-desktop/footer-desktop'
import FooterMobile from './footer-mobile/footer-mobile'
import usePCWindow from 'hooks/usePCWindow'

import { ScreenSize } from 'constants/media-constanst'

import styles from './footer.module.scss'
import { FC, useEffect, useState } from 'react'

const Footer: FC = () => {
  const isStandartPC = usePCWindow(ScreenSize.standart)
  const isMobile = usePCWindow(ScreenSize.mobile)
  const [isAVersion, setIsAVersion] = useState(false)

  useEffect(() => {
    const localFlag = localStorage.getItem('AB_FLAGS')
    setIsAVersion(localFlag === 'new')
    const onFlags = (e: CustomEvent) => {
      const flags = e.detail
      if (flags.new_bar) {
        setIsAVersion(flags.new_bar[0] === 'new')
      }
    }
    window.addEventListener('yandexABFlagsLoaded', onFlags as EventListener)
    return () => window.removeEventListener('yandexABFlagsLoaded', onFlags as EventListener)
  }, [])

  return (
    <footer
      className={styles.footer}
      style={
        isMobile && isAVersion
          ? {
              marginBottom: `56px`,
            }
          : {}
      }
    >
      <MaxWidthLimiter noTopPadding noBottomPadding noLeftPadding noRightPadding>
        <div className={styles.footerWrapper}>
          {isStandartPC ? <FooterDesktop /> : <FooterMobile />}
        </div>
      </MaxWidthLimiter>
    </footer>
  )
}

export default Footer
